export enum ReturnRouteType {
  RETURNS = "returns",
  CLAIMS = "claims",
  WARRANTIES = "warranties",
}
